import { render, staticRenderFns } from "./PsiCopyButton.vue?vue&type=template&id=0cb2ad18&scoped=true&"
import script from "./PsiCopyButton.vue?vue&type=script&lang=js&"
export * from "./PsiCopyButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb2ad18",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})


/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0cb2ad18')) {
      api.createRecord('0cb2ad18', component.options)
    } else {
      api.reload('0cb2ad18', component.options)
    }
    module.hot.accept("./PsiCopyButton.vue?vue&type=template&id=0cb2ad18&scoped=true&", function () {
      api.rerender('0cb2ad18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/lib/src/components/buttons/PsiCopyButton.vue"
export default component.exports